export default {
    getters: {
        DELIVERY_SETTINGS: 'deliverySettings',
        RESTAURANT: 'restaurant',
        ACTIVE_RESTAURANT: 'activeRestaurant',
        RESTAURANT_ID: 'restaurantId',
    },
    mutations: {
        SET_DELIVERY_SETTINGS: 'setDeliverySettings',
        SET_RESTAURANT: 'setRestaurant',
        SET_ACTIVE_RESTAURANT: 'setActiveRestaurant',
        SET_ACTIVE_RESTAURANT_ID: 'setActiveRestaurantId',
    },
    actions: {
        SET_ACTIVE_RESTAURANT_ID: 'setActiveRestaurantId',
        GET_RESTAURANT: 'getRestaurant',
    },
}
